import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input, Textarea} from '../form';
// import {enquiry} from '../../api/'

class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() }>
        <Input name="email"
               type="email"
               label="Your Email"
               showErrors={showErrors}
               validations="isEmail"
               validationError="This is not a valid email"
               inputSize="pt-large"
               required />
        <Textarea name="message"
                  showErrors={showErrors}
                  label="Message"
                  required />
        {serverError && (
          <div className="pt-callout pt-intent-danger s4">
            {serverError}
          </div>
        )}
        {!isProcessing ? (
          <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Send</button>
        ) : (
          <button type="submit" className="pt-button pt-disabled pt-large pt-icon-log-in">Sending...</button>
        )}

      </Formsy>
    );
  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop } = this.props;
    this.setState({isProcessing: true, serverError: null});

    // Enquiry endpoint disabled: pretend the message was sent.
    // enquiry(model.email, model.message)
    //   .then(() => {
    //     this.setState({isProcessing: false, serverError: null})
    //     onSuccess();
    //   })
    //   .catch((e) => {
    //     this.setState({isProcessing: false, serverError: e})
    //     onError(e);
    //   })
    this.setState({isProcessing: false, serverError: null});
    onSuccess();

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

}

export default ContactForm;


// WEBPACK FOOTER //
// ./src/components/forms/ContactForm.js